import { Pipe, PipeTransform } from "@angular/core";
import { AppService } from "../app.service";
import dayjs from "dayjs";
import { NgModel } from "./custom-consensus-core/custom-consensus-core.component";

@Pipe({
  name: "ccCompare",
  pure: true,
})
export class CcCompare implements PipeTransform {
  constructor(private appService: AppService) {}

  // prettier-ignore
  transform(copy: NgModel, original: NgModel): boolean {
    if (!copy || !original) {
      return true;
    }

    
    let assumeEqual = true;
    if (copy.customConsensusMode === "byBroker") {
      const extraBrokersSelected = copy.includeNonentitledCurrent || copy.includeNonentitledNoncurrent;
      if(copy.customConsensusBrokerType==="reaffirm" && extraBrokersSelected){
        return true
      }
      if (!copy.selectedBrokersByGrid ||(copy.selectedBrokersByGrid.length === 0 && !extraBrokersSelected)) {
        return true;
      }
      if (original.customConsensusMode !== "byBroker"){
        return false;
      }
      assumeEqual = assumeEqual && copy.customConsensusBrokerType === original.customConsensusBrokerType;
      assumeEqual = assumeEqual && copy.hideNonCcBrokersInGrid === original.hideNonCcBrokersInGrid;
      assumeEqual = assumeEqual && copy.includeNonentitledCurrent === original.includeNonentitledCurrent;
      assumeEqual = assumeEqual && copy.includeNonentitledNoncurrent === original.includeNonentitledNoncurrent;
      assumeEqual = assumeEqual && copy.sortColumn === original.sortColumn;
      assumeEqual = assumeEqual && copy.sortDirection === original.sortDirection;
      if(copy.customConsensusBrokerType !== "reaffirm"){
        assumeEqual = assumeEqual && this.appService.compare(
            this.appService.basicSort(this.appService.superClone(copy.selectedBrokersByGrid)),
            this.appService.basicSort(this.appService.superClone(original.selectedBrokersByGrid))
          );
      }
    } else {
      if (!copy.dateCustomConsensus && !copy.relativeDays) {
        return true;
      }

      if (!copy.selectedBrokersByDate || copy.selectedBrokersByDate.length === 0) {
        return true;
      }

      assumeEqual = assumeEqual && copy.hideNonCcBrokersInGrid === original.hideNonCcBrokersInGrid;
      assumeEqual = assumeEqual && copy.includeNonCurrentBrokers === original.includeNonCurrentBrokers;
      assumeEqual = assumeEqual && copy.dateCustomConsensus === original.dateCustomConsensus;
      if(copy.customConsensusDateType === "relative") {
        assumeEqual = assumeEqual && copy.relativeDays === original.relativeDays;
      }


    }
    

    return assumeEqual;
  }
}

@Pipe({
  name: "formatDate",
})
export class FormatDatePipe implements PipeTransform {
  transform(date: Date): string {
    return dayjs(date).format("YYYYMMDD");
  }
}
